export { default as NTag, tagProps } from './src/Tag';
